export const locale = {
  lang: 'en',
  data: {
    ERROR: {
      HTTP: {
        404: {
          'TITLE': '404 ERROR',
          'MESSAGE': 'The page does not exist'
        },
      },
    },
  },
};
